import { createContext, useState } from "react";
import { makeRequest } from "../network/networkRequest";

export type MyContextType = {
  prevPrompts: [string];
  setPrevPrompts: (prompt: [string]) => void;
  onSent: (prompt: string) => Promise<void>;
  setRecentPrompt: (prompt: string) => void;
  recenPrompt: string;
  showResult: boolean;
  loading: boolean;
  resultData: string;
  input: string;
  setInput: (input: string) => void;
};

export const Context = createContext<MyContextType>({} as MyContextType);

const ContextProvider = (props: any) => {
  const [input, setInput] = useState<string>("");
  const [recenPrompt, setRecentPrompt] = useState<string>("");
  const [prevPrompts, setPrevPrompts] = useState<[string]>([""]);
  const [showResult, setShowResult] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [resultData, setResultData] = useState<string>("");

  const onSent = async (prompt: string) => {
    setShowResult(true);
    setLoading(true);
    setResultData("");
    const response = await makeRequest(prompt);
    setResultData(response);
    setLoading(false);
    setRecentPrompt(prompt);
    setInput("");
  };

  const contextValue: MyContextType = {
    prevPrompts,
    setPrevPrompts,
    onSent,
    setRecentPrompt,
    recenPrompt,
    showResult,
    loading,
    resultData,
    input,
    setInput,
  };

  return (
    <Context.Provider value={contextValue}>{props.children}</Context.Provider>
  );
};

export default ContextProvider;
